var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layers-2--Streamline-Lucide"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.1014 12L21.2389 14.9344C21.3832 15.0161 21.5032 15.1347 21.5867 15.278C21.6702 15.4213 21.7142 15.5842 21.7142 15.75C21.7142 15.9158 21.6702 16.0787 21.5867 16.222C21.5032 16.3653 21.3832 16.4839 21.2389 16.5656L13.2702 21.1312C12.9851 21.2958 12.6618 21.3825 12.3327 21.3825C12.0036 21.3825 11.6802 21.2958 11.3952 21.1312L3.42644 16.5656C3.28216 16.4839 3.16215 16.3653 3.07866 16.222C2.99516 16.0787 2.95117 15.9158 2.95117 15.75C2.95117 15.5842 2.99516 15.4213 3.07866 15.278C3.16215 15.1347 3.28216 15.0161 3.42644 14.9344L8.56394 12",
    stroke: "#0094FB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.2712 13.6309C12.9861 13.7955 12.6628 13.8821 12.3337 13.8821C12.0045 13.8821 11.6812 13.7955 11.3962 13.6309L3.42741 9.06526C3.28313 8.9835 3.16313 8.86492 3.07963 8.72164C2.99614 8.57835 2.95215 8.41548 2.95215 8.24964C2.95215 8.0838 2.99614 7.92093 3.07963 7.77764C3.16313 7.63436 3.28313 7.51578 3.42741 7.43402L11.3962 2.86839C11.6812 2.70382 12.0045 2.61719 12.3337 2.61719C12.6628 2.61719 12.9861 2.70382 13.2712 2.86839L21.2399 7.43402C21.3842 7.51578 21.5042 7.63436 21.5877 7.77764C21.6712 7.92093 21.7152 8.0838 21.7152 8.24964C21.7152 8.41548 21.6712 8.57835 21.5877 8.72164C21.5042 8.86492 21.3842 8.9835 21.2399 9.06526L13.2712 13.6309Z",
    stroke: "#0094FB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectsIcon);
export default __webpack_public_path__ + "static/media/ProjectsIcon.ce88837a52c27f02ad6c508ef9d92c87.svg";
export { ForwardRef as ReactComponent };